import React from 'react';
import PropTypes from 'prop-types';
import PitchFxDataContainer from '../../PitchFx/PitchFxDataContainer';
import FieldVisionButtonDataContainer from '../../FieldVision/containers/FieldVisionButtonDataContainer';
import { ChipFeedWrapper, LimitedFunctionalityChip } from '../Live.style';
import { ChipFeedDataContainer } from '../../ChipFeed';
import { ButtonTypes } from '../../FieldVision/components/Button';
import PlayTimerProvider from '@gameday/utils/providers/PlayTimerProvider';

const PitchFxBundle = ({
    onAuthOpen,
    viewType,
    firstRunUser,
    showExplore,
    showLimitedFunctionalityChip,
    limitedFunctionalityMessage,
    nativeLoginFunc
}) => {
    return (<PlayTimerProvider>
        <PitchFxDataContainer viewType={viewType} />
        <FieldVisionButtonDataContainer buttonType={nativeLoginFunc && ButtonTypes.NATIVELOGIN} showPreview={nativeLoginFunc || onAuthOpen} $type={viewType} firstRunUser={firstRunUser} showExplore={showExplore} />
        <ChipFeedWrapper $type={viewType}><ChipFeedDataContainer /></ChipFeedWrapper>
        {showLimitedFunctionalityChip && <LimitedFunctionalityChip $type={viewType}>{limitedFunctionalityMessage}</LimitedFunctionalityChip>}
    </PlayTimerProvider>);
};

PitchFxBundle.propTypes = {
    onAuthOpen: PropTypes.func,
    viewType: PropTypes.string,
    firstRunUser: PropTypes.bool,
    showExplore: PropTypes.func,
    showLimitedFunctionalityChip: PropTypes.bool,
    limitedFunctionalityMessage: PropTypes.string,
    nativeLoginFunc: PropTypes.func
};

export default PitchFxBundle;
